export default __webpack_public_path__ + "static/media/clock-ico.a37960de.svg";